import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <section className="py-24 px-4 bg-dark-800" data-id="element-64">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-65">
        {/* For You */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-900/50 p-8 rounded-2xl border border-amber-500/20" data-id="element-66">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-67">
            <span className="text-amber-500" data-id="element-68">✓</span> Esto es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-69">
            {['Postergas por miedo (no por flojera).', 'Te bloqueas cuando no entiendes.', 'Te pesa estar solo con tus pendientes.', "Te quieres probar que sí puedes empezar sin esperar el 'día perfecto'."].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-70">
                <Check className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-71" />
                <span data-id="element-72">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-dark-900/30 p-8 rounded-2xl border border-white/5 opacity-80" data-id="element-73">
          <h3 className="text-2xl font-bold text-gray-400 mb-6 flex items-center gap-3" data-id="element-74">
            <span className="text-red-900/50" data-id="element-75">✕</span> No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-76">
            {['Buscas eliminar por completo la ansiedad antes de actuar.', 'Quieres una promesa clínica o milagrosa.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-500" data-id="element-77">
                <X className="w-5 h-5 text-red-900/50 shrink-0 mt-0.5" data-id="element-78" />
                <span data-id="element-79">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}